import script from "./base-password.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-password.vue?vue&type=script&setup=true&lang=ts"

import "./base-password.vue?vue&type=style&index=0&id=52561527&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52561527"]])

export default __exports__